import React from 'react';
import IconClose from '@material-ui/icons/Close';

const Close = (props) => <IconClose  className="close" onClick={props.onClick} />;

export default Close;
